import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './RunDataExtractForm.schema'

const inputTypeOptions = [
  {
    label: 'Banks Runs',
    value: 'banks',
  },
  {
    label: 'Custodians Runs',
    value: 'custodians',
  },
] as const

export interface RunDataExtractFormFieldsProps {}

export const RunDataExtractFormFields: React.FC<RunDataExtractFormFieldsProps> = ({}) => {
  const { setValue, formState, control } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="input_type"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Input Type</FormLabel>
              <SelectInput
                className={'w-full'}
                disabled={formState.isSubmitting}
                // @ts-expect-error
                options={inputTypeOptions}
                value={value}
                onValueChange={(val) =>
                  setValue('input_type', val as (typeof inputTypeOptions)[number]['value'], {
                    shouldValidate: true,
                  })
                }
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="report_date"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Input Type</FormLabel>
              <DatePicker
                buttonDisabled={formState.isSubmitting}
                selected={value ? new Date(value) : undefined}
                onSelect={(date) =>
                  date && setValue('report_date', toISO8601(date), { shouldValidate: true })
                }
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
